module.exports = __webpack_public_path__ + "img/featured-tablet-cta-4.7812b299.jpg";